import './loadingMask.css'

const LoadingMask = () => {
    return (
        <div className="loading-mask d-flex justify-content-center align-items-center">
            <div className="a-loading a-primary a-m-10 a-loading-24"></div>
        </div>
    )
}

export default LoadingMask
